import useIssueMC from 'Hooks/teleconsult/useIssueMC';
import { number, shape } from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClinicsOfDoctor } from 'Redux/modules/clinics/actions';
import { removeModal } from 'Redux/modules/modal/actions';
import { Icon, Modal } from 'semantic-ui-react';

import styles from './MCWrapper.less';

const useClinics = () => {
  const dispatch = useDispatch();
  const { status, list } = useSelector(state => state.clinics);
  const doctor = useSelector(state => state.webChat.doctor.data);
  useEffect(() => {
    if (status.loading !== 1 && status.loading !== 0) {
      dispatch(getClinicsOfDoctor(doctor.id));
    }
  }, [dispatch, doctor.id, status.loading]);

  return { status, list };
};

const listDigiClinic = list => list.filter(item => item.digiMcName !== null);

const MCWrapper = props => {
  const {
    data: { conversation },
    id,
  } = props;
  const dispatch = useDispatch();
  const close = () => {
    dispatch(removeModal(id));
  };

  const { status, list } = useClinics();
  const listDigi = listDigiClinic(list);

  const { openToIssueManadrMC, openToIssueDigiMC } = useIssueMC(conversation);

  useEffect(() => {
    if (listDigi.length === 0 && status.loading === 1) {
      openToIssueManadrMC();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listDigi.length, status.loading]);
  const loadingClinics = status.loading === 0;

  return (
    listDigi.length > 0 &&
    status.loading === 1 && (
      <Modal open closeIcon onClose={close} closeOnDimmerClick={false} style={{ width: '820px' }}>
        <Modal.Header>Create Medical Certificate</Modal.Header>
        <Modal.Content loading={loadingClinics} basic>
          <div className={styles.content}>
            <div className={styles.button} onClick={openToIssueManadrMC}>
              <div>
                <p className={styles.typeTitle}>Standard Medical Certificate</p>
                <p>MC is issued in platform.</p>
              </div>
              <Icon name="chevron right" className={styles.icon} />
            </div>
            <div className={styles.button} onClick={openToIssueDigiMC}>
              <div>
                <p className={styles.typeTitle}>Digi Medical Certificate</p>
                <p>
                  The Digital MC, which is authorised by MOH, is issued from the https://mc.gov.sg
                  domain.
                </p>
              </div>
              <Icon name="chevron right" className={styles.icon} />
            </div>
          </div>
        </Modal.Content>
      </Modal>
    )
  );
};

MCWrapper.propTypes = {
  data: shape({
    conversation: shape({}),
  }).isRequired,
  id: number.isRequired,
};

MCWrapper.defaultProps = {};

export default MCWrapper;
